<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'DateRangeFilter',
          name: 'whereDate',
          attributes: { dateField: 'paid_at' }
        }
      ]"
      v-model="filter"
      @apply-filters="$bus.$emit('refresh-table')"
      :autoApply="true"
    ></table-filter>

    <v-table
      url="/api/v1/transaction"
      :filter="filter"
      :attributes="[
        {
          attribute: 'service',
          displayedAttribute: 'translated_service',
          name: 'Zahlungsart- / Dienstleister'
        },
        {
          attribute: 'transactions',
          name: 'Käufe'
        },
        {
          attribute: 'units',
          name: 'Bezahleinheiten'
        },
        {
          attribute: 'revenue',
          name: 'Umsatz',
          type: 'CurrencyCell'
        }
      ]"
      ref="table"
    >
      <tr slot="bottom" v-if="total">
        <td v-for="(attribute, index) in summaryFields" :key="'row-' + index">
          <strong>
            {{ index === 0 ? "Gesamt:" : total[attribute] }}
          </strong>
        </td>
      </tr>
    </v-table>

    <chart-card
      :chart-data="revenueChart"
      :chart-options="revenueChart.options"
      chart-type="Pie"
      :chart-height="175"
    >
      <template slot="header">
        <h5 class="card-title">Umsätze</h5>
        <p class="card-category">Gruppiert nach Zahlungsart- / Dienstleister</p>
      </template>
      <template slot="footer">
        <div></div>
      </template>
    </chart-card>
  </div>
</template>

<script lang="babel">
import ChartCard from "src/components/UIComponents/Cards/ChartCard";

export default {
  components: {
    ChartCard
  },
  data () {
    return {
      total: null,
      summaryFields: ['','transactions', 'units','revenue'],
      revenueChart: {
        labels: [],
        datasets: [],
        options: {
          legend: {
            display: true
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                const formatter = new Intl.NumberFormat('de-DE', {
                  style: 'currency',
                  currency: 'EUR',
                  minimumFractionDigits: 2,
                });

                return tooltipItem.yLabel +
                  ' ' +
                  data.labels[tooltipItem.index] +
                  ': ' +
                  formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              }
            }
          }
        }
      },
      filter: [
        {
          name: 'GroupByService',
        },
        {
          name: 'sort',
          mode: 'DESC',
          attribute: 'service',
        },
        {
          name: 'payment_service',
        }
      ]
    };
  },
  created() {
    this.$bus.$on('table-fetched', () => {
      let labels = [];
      let dataset = {
        label: "Umsätze",
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: ["#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2", "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55", "#e28956", "#e2cf55", "#c2e02c"],
        borderWidth: 0,
        data: []
      };
      this.$refs.table.models.forEach(model => {
        if (model.service === 'Gesamt') {
          return;
        }

        labels.push(this.$store.getters["transaction/dictionaryEntry"](model.service_string));
        dataset.data.push(model.revenue);
      });

      this.revenueChart.labels = labels;
      this.revenueChart.datasets = [dataset];
    });
    let filter =  Object.assign([], this.filter);
    this.$http.get('/api/v1/transaction/sum/',{params: {filter: filter}}).then(({data}) => {
      this.total = data;
    });
  },
  watch: {
    filter() {
      let filter =  Object.assign([], this.filter);
      this.$http.get('/api/v1/transaction/sum/',{params: {filter: filter}}).then(({data}) => {
          this.total = data;
      });
    }
  },
  destroyed () {
    this.$bus.$off('table-fetched');
  }
};
</script>
